import { Product, PromoCode, ReferralCode } from '@boltenergy-be/shared'
import dayjs from 'dayjs'
import { PRODUCT_PROMOS } from './constants'
import { ProductPromo } from './types'

/**
 * Type guard to check if the code is a ReferralCode
 * @param {PromoCode | ReferralCode} code
 * @returns {code is ReferralCode}
 */
export const isReferralCode = (code: PromoCode | ReferralCode): code is ReferralCode => {
  return 'referrer' in code
}

/**
 * @param {Product} product
 * @param {Dayjs} date
 * @returns {ProductPromo | null}
 */
export const getProductPromoForDate = (product: Product, date = dayjs()): ProductPromo | null => {
  const activePromo = PRODUCT_PROMOS.find(
    ({ period, product: promoProduct }) => promoProduct === product && date.isBetween(period.start, period.end)
  )

  return activePromo || null
}
